module.exports = __webpack_public_path__ + "img/flag_ru_medium.e4d1356c.png";